// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Status_componentWrapper__PcBbm","message":"Status_message__KmLMb"};